export default __webpack_public_path__ + "static/media/497.903b1303.png";